

// @ts-nocheck

import Vue from 'vue'

export default Vue.extend({
    props: {
        heading: String,
        secondary: String,
        ask: String
    }
})

